import { memo, Fragment } from 'react';

import { useTranslation } from '@crehana/i18n';
import { Col, TextLink } from '@crehana/ui/';
import { useCollapse } from '@crehana/react-hooks';

import { SEOLink } from './types';

interface LinksColumnProps {
  title: string;
  links: SEOLink[];
  className?: string;
  isDark: boolean;
}

const LinksColumn: React.FC<LinksColumnProps> = memo(
  ({ title, links, className = '', isDark = true }) => {
    const { t } = useTranslation();
    const { getToggleProps, getCollapseProps, isOpen } = useCollapse();
    const visibleLinks = links.slice(0, 5);
    const collapsedLinks = links.slice(5);

    return (
      <Col
        sm={3}
        offset={{
          xs: 1,
          sm: 2,
          md: 0,
        }}
        nowrap
        className={className}
      >
        <h4
          className={`inline-block mb-32 font-button ${
            isDark ? 'text-gray-dark' : 'text-base-dark'
          }`}
        >
          {title}
        </h4>

        <ul className="font-body4">
          {visibleLinks.map(l => (
            <li key={l.id} className="w-full pb-12">
              <a
                href={l.href}
                className={`block truncate transition-all  ${
                  isDark
                    ? 'text-gray-dark hover:text-white'
                    : 'text-base-dark hover:text-secondary-main'
                }`}
              >
                {l.label}
              </a>
            </li>
          ))}

          {collapsedLinks.length ? (
            <Fragment>
              {/* @ts-ignore */}
              <ul {...getCollapseProps()}>
                {collapsedLinks.map(l => (
                  <li key={l.label} className="w-full pb-12">
                    <a
                      href={l.href}
                      className={`block truncate transition-all hover:text-white ${
                        isDark ? 'text-gray-light' : 'text-base-dark'
                      }`}
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>

              <li>
                {/* @ts-ignore */}
                <TextLink
                  label={t(isOpen ? 'SEO_SEE_LESS' : 'SEO_SEE_MORE')}
                  {...getToggleProps()}
                />
              </li>
            </Fragment>
          ) : null}
        </ul>
      </Col>
    );
  },
);

export default LinksColumn;
